import React, { useState, useEffect /*useRef*/ } from 'react'
import { ArrowLeft, Mail, KeyRound, Loader, Phone } from 'lucide-react'
import apiService from '../../services/apiService'
import './AuthFlow.scss'
import authService from '../../services/authService'
// const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITEKEY

const Login = ({ onBack, isRenewSubscription, onLoginSuccess }) => {
  const [step, setStep] = useState(1) // 1: email/phone, 2: code
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [errorCode, setErrorCode] = useState('')
  const [shopId, setShopId] = useState('')
  const [timeLeft, setTimeLeft] = useState(0)
  // const widgetIdRef = useRef(null)
  // const tokenRef = useRef(null)

  const isValidObjectId = (id) => /^[a-fA-F0-9]{24}$/.test(id)
  const queryParams = new URLSearchParams(window.location.search)
  const logManager = isValidObjectId(queryParams.get('shopId'))
    ? queryParams.get('shopId')
    : null

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [timeLeft])

  // useEffect(() => {
  //   if (logManager && !document.getElementById('cf-turnstile')) {
  //     const s = document.createElement('script')
  //     s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
  //     s.id = 'cf-turnstile'
  //     s.async = true
  //     s.defer = true
  //     document.body.appendChild(s)
  //   }
  // }, [logManager])

  // useEffect(() => {
  //   if (logManager) {
  //     let mounted = true
  //     const tryRender = () => {
  //       if (!mounted) return
  //       if (!window.turnstile) {
  //         setTimeout(tryRender, 300)
  //         return
  //       }
  //       let container = document.getElementById('turnstile-container')
  //       if (!container) {
  //         container = document.createElement('div')
  //         container.id = 'turnstile-container'
  //         document.getElementById('turnstile-root').appendChild(container)
  //       }
  //       widgetIdRef.current = window.turnstile.render(container, {
  //         sitekey: SITE_KEY,
  //         callback: (token) => {
  //           tokenRef.current = token
  //         },
  //         'error-callback': () => {
  //           tokenRef.current = null
  //         },
  //         'expired-callback': () => {
  //           tokenRef.current = null
  //         },
  //       })
  //     }
  //     tryRender()
  //     return () => {
  //       mounted = false
  //     }
  //   }
  // }, [logManager])

  const handleRequestCode = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        // if (
        //   logManager
        //   &&
        //   !tokenRef.current &&
        //   window.turnstile &&
        //   widgetIdRef.current !== null
        // ) {
        //   try {
        //     window.turnstile.reset(widgetIdRef.current)
        //     await new Promise((r) => setTimeout(r, 700))
        //   } catch {}
        // }
        // const turnstileToken = tokenRef.current
        // if (logManager && !turnstileToken) {
        //   setError('Impossible de vérifier le captcha.')
        //   setLoading(false)
        //   return
        // }

        const response = logManager
          ? await apiService.requestManagerOTP(
              phone,
              logManager,
              // turnstileToken && logManager ? turnstileToken : undefined,
            )
          : await apiService.requestLoginCode(email)

        if (response.success) {
          setStep(2)
          setTimeLeft(response.data.expiresIn)
        } else {
          setError(response.error || "Erreur lors de l'envoi du code")
        }
      } catch (err) {
        setError('Erreur de connexion. Vérifiez votre connexion internet.')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleVerifyCode = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        const response = logManager
          ? await apiService.verifyManagerOTP(phone, code, logManager)
          : await apiService.verifyLoginCode(email, code)

        if (response.success) {
          onLoginSuccess(response.data)
        } else {
          setError(response.error || 'Code invalide')
          setShopId(response.shopId || null)
          setErrorCode(response.code || null)
        }
      } catch (err) {
        setError('Erreur de connexion. Vérifiez votre connexion internet.')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleResendCode = async () => {
    setError('')
    setCode('')
    setLoading(true)
    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        const response = await apiService.requestLoginCode(email)

        if (response.success) {
          setTimeLeft(response.data.expiresIn)
          setError('')
        } else {
          setError(response.error)
        }
      } catch (err) {
        setError('Erreur lors du renvoi du code')
      } finally {
        setLoading(false)
      }
    }
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  const goToRenewSubscription = async () => {
    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      const renewSubscription = true
      isRenewSubscription({ shopId, renewSubscription, flowFrom: 'login' })
    }
  }

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        <button onClick={onBack} className='btn-back'>
          <ArrowLeft size={20} />
        </button>
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
      </div>

      <div className='auth-card'>
        {step === 1 ? (
          <>
            <h2 className='auth-card-title'>
              {logManager ? 'Espace gérant' : 'Connexion'}
            </h2>
            <p className='auth-card-subtitle'>
              Entrez votre {logManager ? 'numéro' : 'adresse email'} pour
              recevoir un code de vérification
            </p>

            <form onSubmit={handleRequestCode} className='auth-form'>
              {!logManager && (
                <div className='form-field'>
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <Mail size={16} /> Adresse email *
                  </label>
                  <input
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder='exemple@email.com'
                    required
                    disabled={loading}
                  />
                </div>
              )}

              {logManager && (
                <div className='form-field'>
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <Phone size={16} /> Numéro de téléphone *
                  </label>
                  <input
                    type='tel'
                    name='phone'
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder='Ex : +224610101010'
                    required
                    disabled={loading}
                  />
                </div>
              )}

              {/* <div id='turnstile-root' style={{ display: 'none' }} /> */}
              {error && <div className='auth-error'>{error}</div>}
              {error && errorCode === 'IS_EXPIRED_SUBS' && (
                <div className='renewSubscriptionButton'>
                  Renouvelez votre abonnement dès maintenant pour accéder à
                  votre espace.
                  <span onClick={goToRenewSubscription}>
                    👉 Cliquez ici pour le renouveler.
                  </span>
                </div>
              )}

              <button
                type='submit'
                className='btn primary lg full'
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader size={20} className='btn-icon spinning' />
                    Envoi en cours...
                  </>
                ) : (
                  'Recevoir le code'
                )}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className='auth-card-title'>Vérification</h2>
            <p className='auth-card-subtitle'>
              Un code à 6 chiffres a été envoyé {logManager ? 'au' : 'à'}{' '}
              <strong>{logManager ? phone : email}</strong>
            </p>

            <form onSubmit={handleVerifyCode} className='auth-form'>
              <div className='form-field'>
                <label
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <KeyRound size={16} /> Code de vérification
                </label>
                <input
                  type='text'
                  value={code}
                  onChange={(e) =>
                    setCode(e.target.value.replace(/\D/g, '').slice(0, 6))
                  }
                  placeholder='000000'
                  maxLength={6}
                  required
                  disabled={loading}
                  className='code-input'
                />
              </div>

              {timeLeft > 0 && (
                <div className='code-timer'>
                  Code valide pendant {formatTime(timeLeft)}
                </div>
              )}

              {error && <div className='auth-error'>{error}</div>}
              {error && errorCode === 'IS_EXPIRED_SUBS' && (
                <div className='renewSubscriptionButton'>
                  Renouvelez votre abonnement dès maintenant pour accéder à
                  votre espace.
                  <span onClick={goToRenewSubscription}>
                    👉 Cliquez ici pour le renouveler.
                  </span>
                </div>
              )}

              <button
                type='submit'
                className='btn primary lg full'
                disabled={loading || code.length !== 6}
              >
                {loading ? (
                  <>
                    <Loader size={20} className='btn-icon spinning' />
                    Vérification...
                  </>
                ) : (
                  'Vérifier le code'
                )}
              </button>

              {timeLeft <= 0 && (
                <button
                  type='button'
                  onClick={handleResendCode}
                  className='btn secondary lg full'
                  disabled={loading || timeLeft > 0}
                >
                  Renvoyer le code
                </button>
              )}

              <button
                type='button'
                onClick={() => {
                  setStep(1)
                  setCode('')
                  setError('')
                }}
                className='btn-text'
              >
                Changer {logManager ? 'de numéro' : "d'email"}
              </button>
            </form>
          </>
        )}
      </div>

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default Login
